import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import withMerchantMetrics, {
  MetricsProps,
} from 'components/metrics/withMerchantMetrics'
import useSegmentCampaign from 'hooks/useSegmentCampaign'
import { buildTranslate } from 'locales'
import type { Fields as TargetSegment } from 'models/TargetSegment'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import Helmet from 'react-helmet'
import { useDispatch } from 'react-redux'
import { push } from 'react-router-redux'
import NewSegmentCampaignModal from 'scenes/CampaignCenter/Landing/NewSegmentCampaignModal'
import { useAbility } from 'utilities/ability'
import Content from './Content'

const t = buildTranslate('segments.landing')

const Landing: React.FC<MetricsProps> = ({
  merchantMetrics = {},
  merchantMetricStatuses = {},
}) => {
  const [css] = useStyletron()
  const {
    showModal,
    selectedSegment,
    openCampaignModal,
    closeModal,
    createCampaign,
  } = useSegmentCampaign()
  const dispatch = useDispatch()
  const ability = useAbility()
  const canManageSegments = ability.can('manage', 'Segments')
  const redirectToSegmentAI = () => dispatch(push('/segments/ai-builder'))

  const openNewSegmentCampaignModal = (segment: TargetSegment) => {
    openCampaignModal(segment)
  }

  return (
    <>
      <div className="w-100 h-100 pt-m pb-xxl px-0 white-bkg border-bottom-1 grey-20-border">
        <Container className="pt-m pb-xl">
          <div className="d-flex justify-content-between">
            <Text.Header2 className="m-0 mr-xl">{t('title')}</Text.Header2>
            {canManageSegments && (
              <Button onClick={redirectToSegmentAI}>
                {t('create_new_segment')}
              </Button>
            )}
          </div>
        </Container>
        <Helmet>
          <title>{t('page_title')}</title>
        </Helmet>
        <div
          className={`grey-05-bkg border-top-1 pb-xxl grey-20-border pt-xl ${css(
            {
              minHeight: 'calc(100vh - 80px)',
            }
          )}`}
        >
          <Container>
            <Content
              onExistingClick={openNewSegmentCampaignModal}
              merchantMetrics={merchantMetrics}
              merchantMetricStatuses={merchantMetricStatuses}
            />
          </Container>
        </div>
      </div>

      <NewSegmentCampaignModal
        isOpen={showModal}
        onClose={closeModal}
        segment={selectedSegment}
        onCreate={createCampaign}
      />
    </>
  )
}

export default withMerchantMetrics(['user_count'])(Landing)
